<template>
  <urun-areas-layout>
    <div>
      <div class="mb-3">
        <div>
          <panel-title
            icon="mdi-feather"
            :title="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.TITLE')"
            :desc="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.SUB_TITLE')"
          >
          </panel-title>
        </div>
      </div>
    </div>
    <div>
      <div v-if="ozellikListesi.length && ozelliklerStatus">
        <div class="d-flex flex-wrap">
          <v-card
            :key="key"
            v-for="(ozellik, key) in ozellikListesi"
            color="blue"
            dark
            class="d-flex justify-content-center align-center text-subtitle-2 pl-3 pr-2 py-1 mr-2"
          >
            <span class="mr-2">{{ ozellik.name }}</span>
            <v-btn icon x-small :loading="ozellikDuzenleLoading[ozellik.code]" @click="ozellikDuzenleDialog(ozellik.code)">
              <v-icon size="15">mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon x-small color="blue lighten-4" @click="ozellikSilDialog(ozellik.code)">
              <v-icon size="15">mdi-delete</v-icon>
            </v-btn>
          </v-card>
          <v-btn
            outlined
            class="d-flex justify-center align-center text-subtitle-2 text-capitalize px-3 py-1"
            color="blue"
            elevation="0"
            @click="ozellikEkle.dialog = true"
          >
            <v-icon class="mr-1" color="blue" size="16">mdi-plus-circle</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.ADD_FEATURE_BTN") }}
          </v-btn>
        </div>
      </div>
      <div v-else-if="!ozellikListesi.length && ozelliklerStatus">
        <v-alert type="info" icon="mdi-alert">
          <p>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.NO_PRODUCT_FEATURE_ADDITIONAL") }}</p>
          <v-btn small class="text-capitalize" @click="ozellikEkle.dialog = true">
            <v-icon left>mdi-plus</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.CLICK_TO_ADD_NEW_FEATURE") }}
          </v-btn>
        </v-alert>
      </div>
      <div v-else>
        <div class="d-flex flex-wrap">
          <v-skeleton-loader type="button" class="mb-2 mr-2" :key="n" v-for="n in 30"></v-skeleton-loader>
        </div>
      </div>

      <!-- Özellik Ekle Dialog -->
      <v-dialog max-width="700" v-model="ozellikEkle.dialog">
        <v-card>
          <v-card-title class="blue white--text mb-5">
            <v-icon left size="25" dark>mdi-plus</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.ADD_FEATURE_DIALOG.TITLE") }}
            <v-spacer></v-spacer>
            <v-btn dark icon @click="ozellikEkleDialogKapat">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              prepend-inner-icon="mdi-arrow-right"
              :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.ADD_FEATURE_DIALOG.FEATURE_NAME_LABEL')"
              v-model="ozellikEkle.ozellikAdi"
            ></v-text-field>
            <v-text-field
              prepend-inner-icon="mdi-arrow-right"
              :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.ADD_FEATURE_DIALOG.FEATURE_DESC_LABEL')"
              v-model="ozellikEkle.ozellikAciklamasi"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="blue" class="mr-1" @click="yeniOzellikEkle" :loading="ozellikEkle.loading">
              <v-icon left>mdi-plus-circle</v-icon>
              {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.ADD_FEATURE_DIALOG.FEATURE_ADD_BTN") }}
            </v-btn>
            <v-btn dark color="red" @click="ozellikEkleDialogKapat">
              <v-icon left>mdi-cancel</v-icon>
              {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.ADD_FEATURE_DIALOG.CANCEL_BTN") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ./Özellik Ekle Dialog -->

      <!-- Özellik Düzenle Dialog -->
      <v-dialog max-width="700" v-model="ozellikDuzenle.dialog">
        <v-card>
          <v-card-title class="blue white--text mb-5">
            <v-icon left size="25" dark>mdi-plus</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.EDIT_FEATURE_DIALOG.TITLE") }}
            <v-spacer></v-spacer>
            <v-btn dark icon @click="ozellikDuzenle.dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              prepend-inner-icon="mdi-arrow-right"
              :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.EDIT_FEATURE_DIALOG.FEATURE_NAME_LABEL')"
              v-model="ozellikDuzenle.ozellikAdi"
            ></v-text-field>
            <v-text-field
              prepend-inner-icon="mdi-arrow-right"
              :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.EDIT_FEATURE_DIALOG.FEATURE_DESC_LABEL')"
              v-model="ozellikDuzenle.ozellikAciklamasi"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="success" class="mr-1" @click="ozellikGuncelle" :loading="ozellikDuzenle.loading">
              <v-icon left>mdi-refresh</v-icon>
              {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.EDIT_FEATURE_DIALOG.FEATURE_EDIT_BTN") }}
            </v-btn>
            <v-btn dark color="red" @click="ozellikDuzenle.dialog = false">
              <v-icon left>mdi-cancel</v-icon>
              {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.EDIT_FEATURE_DIALOG.CANCEL_BTN") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ./Özellik Düzenle Dialog -->

      <!-- Özellik Kaldır Dialog -->
      <v-dialog v-model="ozellikKaldir.dialog" max-width="500">
        <v-card>
          <v-card-title class="headline red--text text--darken-4">
            <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.DELETE_FEATURE_DIALOG.TITLE") }}
          </v-card-title>
          <v-card-text>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.DELETE_FEATURE_DIALOG.INFO_CONTENT") }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="ozellikKaldir.dialog = false">
              {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.DELETE_FEATURE_DIALOG.CANCEL_BTN") }}
            </v-btn>
            <v-btn color="green darken-1" text :loading="ozellikKaldir.loading" @click="ozellikSil">
              {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_FEATURES_AREA.DELETE_FEATURE_DIALOG.OK_BTN") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ./Özellik Kaldır Dialog -->
    </div>
  </urun-areas-layout>
</template>

<script>
import PanelTitle from "../../../../components/PanelTitle.vue";
import UrunAreasLayout from "./UrunAreasLayout.vue";
import { mapState } from "vuex";

export default {
  components: { UrunAreasLayout, PanelTitle },
  name: "UrunOzellikleri",
  computed: {
    ...mapState({
      /**
       * @returns {Array}
       */
      ozellikListesi: state => state.Urunler.UrunOzellikleri.ozellikListesi
    })
  },
  data: () => ({
    ozelliklerStatus: false,
    ozellikKaldir: {
      dialog: false,
      ozellikCode: null,
      loading: false
    },
    ozellikDuzenle: {
      dialog: false,
      ozellikAdi: "",
      ozellikAciklamasi: "",
      loading: false,
      ozellikCode: null
    },
    ozellikDuzenleLoading: [],
    ozellikEkle: {
      dialog: false,
      ozellikAdi: "",
      ozellikAciklamasi: "",
      loading: false
    }
  }),
  methods: {
    /**
     * Yeni bir ürün özelliği eklemesi yapar
     *
     * @returns {Void}
     */
    yeniOzellikEkle() {
      const { ozellikAdi, ozellikAciklamasi } = this.ozellikEkle;
      this.ozellikEkle.loading = true;
      this.$store
        .dispatch("Urunler/UrunOzellikleri/ozellikEkle", {
          ozellikAdi,
          ozellikAciklamasi
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_FEATURES.FEATURE_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.ozellikEkleDialogKapat();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.ozellikEkle.loading = false;
        });
    },
    /**
     * Seçili özelliğe ait detay verisin getirir ve
     * düzenleme dialog'unu açar
     *
     * @returns {Void}
     */
    ozellikDuzenleDialog(ozellikCode) {
      this.ozellikDuzenleLoading[ozellikCode] = true;
      this.$UrunlerService
        .ozellikDetay(ozellikCode)
        .then(res => {
          if (res.status === 200) {
            this.ozellikDuzenle.ozellikCode = res.data.code;
            this.ozellikDuzenle.ozellikAdi = res.data.name;
            this.ozellikDuzenle.ozellikAciklamasi = res.data.desc;
            this.ozellikDuzenle.dialog = true;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.$set(this.ozellikDuzenleLoading, ozellikCode, false);
        });
    },
    /**
     * Herhangi bir ürün özelliğinin düzenlemesini yapar
     *
     * @returns {Void}
     */
    ozellikGuncelle() {
      const { ozellikCode, ozellikAdi, ozellikAciklamasi } = this.ozellikDuzenle;
      this.ozellikDuzenle.loading = true;
      this.$store
        .dispatch("Urunler/UrunOzellikleri/ozellikDuzenle", {
          ozellikCode,
          ozellikAdi,
          ozellikAciklamasi
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_FEATURES.FEATURE_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.ozellikDuzenle.dialog = false;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.ozellikDuzenle.loading = false;
        });
    },
    ozellikSilDialog(ozellikCode) {
      this.ozellikKaldir.ozellikCode = ozellikCode;
      this.ozellikKaldir.dialog = true;
    },
    ozellikSil() {
      this.ozellikKaldir.loading = true;
      this.$store
        .dispatch("Urunler/UrunOzellikleri/ozellikKaldir", this.ozellikKaldir.ozellikCode)
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_FEATURES.FEATURE_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.ozellikKaldir.dialog = false;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.ozellikKaldir.loading = false;
        });
    },
    /**
     * Özellik ekleme dialog'unu kapatır
     *
     * @returns {Void}
     */
    ozellikEkleDialogKapat() {
      this.ozellikEkle.dialog = false;
      this.ozellikEkle.ozellikAdi = "";
      this.ozellikEkle.ozellikAciklamasi = "";
    }
  },
  created() {
    // Ürün özellikleri listesini getir
    this.$store.dispatch("Urunler/UrunOzellikleri/ozellikListesi").then(() => {
      this.ozelliklerStatus = true;
    });
  }
};
</script>

<style></style>
